export const merchandising_columns = [
  {
    title: 'Location number',
    dataIndex: 'locationNumber',
    key: 'action',
    width: 120,
    fixed: 'left',
  },
  {
    title: 'Location name',
    dataIndex: 'locationName',
    key: 'locationName',
    width: 250,
  },
  {
    title: 'Merchandising Tier',
    dataIndex: 'merchandisingTier',
    key: 'merchandisingTier',
    width: 180,
  },
  {
    title: 'Total Frame Capacity',
    dataIndex: 'totalFrameCapacity',
    key: 'totalFrameCapacity',
    width: 180,
  },
  {
    title: 'Branded Fixture Capacity',
    dataIndex: 'brandedFixtureCapacity',
    key: 'brandedFixtureCapacity',
    width: 210,
  },
  {
    title: 'Generic Fixture Capacity',
    dataIndex: 'genericFixtureCapacity',
    key: 'genericFixtureCapacity',
    width: 210,
  },
  {
    title: 'Frame Capacity Group',
    dataIndex: 'frameCapacityGroup',
    key: 'frameCapacityGroup',
    width: 180,
  },
];
